import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsPfdodCheckMixin extends Vue {
  get isPfdodModule() {
    return !!this.$store.getters.hasApiModulePfdod;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isPfdodCheck.ts